
import 'element-ui/lib/theme-chalk/time-picker.css';
import 'element-ui/lib/theme-chalk/icon.css';

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class orderList extends Vue {
    @Prop() isClassification!: any;
    @Prop() classData!: any;
    @Prop() classificationList!: any;
    @Prop() goodsListData!: any;     // 商品列表
    isShow: Boolean = true
    classCenter: Boolean = true
    classificationName: String = ''
    currentStatus: String = ''
    optionalList: any = []   // 可选择的分类列表
    prohibitStatus: any = []
    uodateId:any = ''
    @Watch('isShow')
    onChange(val: any) {
        if (!val) {
            this.$emit('hintChange', { name: 'isClassification', val: val })
        }
    }
    created() {
        this.optionalList = this.goodsListData.reduce((p: any, c: any) => ({
            ...p, [c.listId]: false
        }), {}
        )
    }
    upDateChoice(data: any) {
        this.optionalList[data] = !this.optionalList[data]
    }
    updateList() {   // 更新自定义分类
        if (this.currentStatus == '修改') {
            if (this.classificationName.length < 1) {
                this.$toast('请设置分类名称！')
                return
            }else{
                let dataS:any = []
                for (const key in this.optionalList) {
                    if(this.optionalList[key]) dataS.push(key)
                }
                this.$emit('modifyList',{
                    listIds:dataS.join(),
                    name:this.classificationName,
                    id:this.uodateId
                })
            }
        } else if (this.currentStatus == '添加') {
            let isCheckout = Object.values(this.optionalList).some(item => item)
            if (isCheckout && this.classificationName.length > 0) {
                let addList: any = []
                for (const key in this.optionalList) {
                    if (this.optionalList[key]) {
                        addList.push(Number(key))
                    }
                }
                this.$emit('addList', {
                    room_id: Number(this.$route.params.id),
                    category_name: this.classificationName,
                    list_ids: addList,
                })
            } else {
                this.$toast('请设置分类名称，并选中商品')
            }
        }
    }
    deleteItem(data: any) {    // 删除分类
        this.$dialog.confirm({
            title:"确认要删除此分类吗？"
        }).then(()=>{
            this.$emit('dalateItem',data)
        })
    }
    modify(data: any) {      // 修改分类
        // 分类ID
        this.uodateId = data.id
        // 分类名
        this.classificationName = data.categoryName
        // 所有分类ID列表
        let allClassIds =  Array.from(new Set(this.classData.map((item: any) => item.listIds.split(",")).flat()))
        // 当前的分类ID列表
        let currentClassIDs = data.listIds.split(',')
        allClassIds = allClassIds.filter(item => !currentClassIDs.includes(item))
        this.prohibitStatus = new Set(allClassIds)
        // 勾选当前分类的商品
        this.goodsListData.forEach((item: any) => {
            this.optionalList[item.listId] = currentClassIDs.includes(item.listId + '')
        })
        this.currentStatus = '修改'
        this.classCenter = false
    }
    addClassification() { // 新增分类
        this.prohibitStatus = new Set(this.classData.map((item: any) => item.listIds.split(",")).flat())
        this.optionalList = {}
        this.classCenter = false
        this.classificationName = ''
        this.currentStatus = '添加'
    }
}